import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Rechteverwaltung')
    .setRoute('acl_user_list')
    .setAdditionalRoutes([
        'acl_edit_user_roles',

    ]);
